/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = None

1 = Cost Code

2 = Change order

3 = Estimate Group

4 = Unbudgeted Selection


 */
export type InvoiceLineItemGroupType =
  (typeof InvoiceLineItemGroupType)[keyof typeof InvoiceLineItemGroupType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvoiceLineItemGroupType = {
  None: 0,
  CostCode: 1,
  ChangeOrder: 2,
  EstimateGroup: 3,
  UnbudgetedSelection: 4,
} as const;
